import React, { useState } from 'react';
import { isFunction } from 'lodash';
import styled from 'styled-components';
import { ArrowDropDown, ArrowDropUp } from '@mui/icons-material';

function FormSectionSeparator({
  name,
  children,
  onChange,
  oppositeLabel,
  defaultValue = true,
}) {
  const [checked, setChecked] = useState(defaultValue);

  const click = () => {
    if (isFunction(onChange)) {
      setChecked(!checked);
      onChange({ target: { name, checked: !checked, type: 'checkbox' } });
    }
  };

  return (
    <Wrap>
      <Label onClick={click} className={onChange ? 'toggleable' : ''}>
        {checked ? children : oppositeLabel}
        {onChange && (checked ? <ArrowDropDown /> : <ArrowDropUp />)}
      </Label>
    </Wrap>
  );
}

const Wrap = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
  position: relative;
  margin: 10px 0 30px;
  &:after {
    content: '';
    width: 100%;
    height: 1px;
    background: #ccc;
    position: absolute;
    left: 0;
    top: 0;
    margin: 16px 0 0 0;
  }
`;

const Label = styled.div`
  display: flex;
  position: relative;
  flex-direction: row;
  padding: 0 10px;
  height: 36px;
  background: #fff;
  align-items: center;
  text-transform: uppercase;
  font-size: 12px;
  color: #999;
  z-index: 1;
  &.toggleable {
    cursor: pointer;
  }
  .MuiSvgIcon-root {
    margin-left: -5px;
    position: relative;
    left: 7px;
  }
`;

export default FormSectionSeparator;
